var enteredSearchTerm;

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function startAnalytics() {
    console.log('analytics started');
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'functionality_storage': 'granted',
        'personalization_storage': 'granted',
        'security_storage': 'granted'
    });
    if (typeof window['loadProductGA'] === 'function') {
        loadProductGA();
    }
}

function stopAnalytics() {
    console.log('updating gtag consent to denied all');
    gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'denied'
    });
}

function hasSeenGDPR() {
    let gdprStatus = getCookie('gdpr');
    if (gdprStatus.length > 0) return true;
    else return false;
}

function hasAcceptedGDPR() {
    let gdprStatus = getCookie('gdpr');
    let rlxConsent = getCookie('rlx-consent');
    if (gdprStatus == 'accepted' && rlxConsent == "true") return true;
    else return false;
}
function acceptGDPR() {
    setCookie('gdpr', 'accepted', 365);
    setCookie('rlx-consent', 'true', 365);
    let settings = {
        essential: true,
        analytics: true,
        rolex: true
    };
    applyGDPRSettings(settings);
    return true;
}

function declineGDPR() {
    setCookie('gdpr', 'declined', 365);
    let settings = {
        essential: true,
        analytics: false,
        rolex: false
    };
    applyGDPRSettings(settings);
    return true;
}

function applyGDPRSettings(settings) {
    console.log('start apply gdpr settings')
    if (settings.essential == true) {
        setCookie('gdpr', 'accepted', 365);
        setCookie('gdpr-essential', 'true', 365);
        console.log('settings essential true')
    }
    else {
        setCookie('gdpr', 'declined', 365);
        setCookie('gdpr-essential', 'false', 365);
        console.log('settings essential false')
    }

    if (settings.analytics == true) {
        setCookie('gdpr', 'accepted', 365);
        setCookie('gdpr-analytics', 'true', 365);
        console.log('settings analytics true')
    }
    else {
        setCookie('gdpr', 'declined', 365);
        setCookie('gdpr-analytics', 'false', 365);
        console.log('settings analytics false')
    }

    if (settings.rolex == true) {
        setCookie('gdpr', 'accepted', 365);
        setCookie('gdpr-rolex', 'true', 365);
        console.log('settings rolex true')
    }
    else {
        setCookie('gdpr', 'accepted', 365);
        setCookie('gdpr-rolex', 'false', 365);
        console.log('settings rolex false')
    }
    applyTrackingSettings();
    return true;
}
function applyTrackingSettings() {
    console.log('Applying tracking settings');
    let gdprStatus        = getCookie('gdpr');
    // let rlxConsent        = getCookie('rlx-consent');
    // let essentialTracking = getCookie('gdpr-essential');
    let analyticsTracking = getCookie('gdpr-analytics');
    let rolexTracking     = getCookie('gdpr-rolex');
    let satelliteVar      = "false";

    let rolexScript = document.createElement('script');
    if (document.body.classList.contains('is_rolex')) {
        if (!document.body.classList.contains('single-cpt_news') && !document.body.classList.contains('page-id-88469')) {
            rolexScript.setAttribute('src', 'https://assets.adobedtm.com/7e3b3fa0902e/7ba12da1470f/launch-5de25e657d80.min.js');
            document.body.appendChild(rolexScript);
            console.log('appended rolex tracking code to document.body');
        }
    }

    if (gdprStatus == "accepted") {
        console.log('gdpr status is accepted, start tracking code');

        if (analyticsTracking == 'true') {
            console.log('gdpr analytics is true');
            startAnalytics();
        }
        else {
            console.log('gdpr analytics is false');
            stopAnalytics();
        }

        if (rolexTracking == 'true') {
            console.log('gdpr rolex is true');
            setCookie('rlx-consent', 'true', 365);
            // _satellite.setVar("Analyticsconsent","true");
            satelliteVar = "true";
        }
        else {
            console.log('gdpr rolex is false');
            setCookie('rlx-consent', 'false', 365);
            // _satellite.setVar("Analyticsconsent","false");
        }
    }
    else if (gdprStatus == 'declined') {
        console.log("gdpr Status is declined, stop all tracking.")
        stopAnalytics();
        setCookie('rlx-consent', 'false', 365);
        satelliteVar = "false";
        console.log('stopped rolex tracking');
    }

    if (document.body.classList.contains('is_rolex')) {
        rolexScript.addEventListener('load', () => {
            console.log('rolex tracking script loaded');
            _satellite.setVar('Analyticsconsent', satelliteVar);
            console.log('rolex tracking satellite variable set to: ' + satelliteVar);
        });
    }
}

function initUtmCookies() {
    if (location.search.length > 0) {
        // get the UTM values from location.search
        const urlSearchParams = new URLSearchParams(location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        var cookieString = "";
        if (Object.entries(params).length > 0) {
            for (const [key, value] of Object.entries(params)) {
                if (key.substring(0, 4) == 'utm_') {
                    cookieString += key + '=' + value + '&';
                }
            }
            if (cookieString.length > 0) cookieString = cookieString.replace(/&+$/, '');
        }
        if (cookieString.length > 0) document.cookie = "utm_values=" + encodeURIComponent(cookieString) + "; path=/; max-age=" + (60 * 60 * 24) + "; secure;";
        return true;
    }
    return false;
}

(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var players = [];
    var st;
    var scrollDir;
    var lastSt = 0;
    var touch;
    var map;

    var mapStyles = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }]

    if ($('html').hasClass('mobile')) touch = true
    else touch = false

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (document.documentElement && document.documentElement.clientWidth)
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
        else if (document.documentElement && document.documentElement.clientHeight)
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }

    function initSliders(){
        var $slider = $('.js-slider .main-carousel')
        $slider.on( 'ready.flickity', function() {
            $(this).find('.flickity-button').css('top', $(this).find('figure').outerHeight()/2);
        });

        if ($slider.parents('.module-homepage__hero-with-slider')) {
            var flkty = $slider.flickity({
                cellAlign: 'left', 
                contain: true,
                wrapAround: true,
                autoPlay: 5500,
                pauseAutoPlayOnHover: false,
                selectedAttraction: 0.015
            });

            // Resume autoplay after user interaction
            $slider.on('mouseleave.flickity', function() {
                flkty.data('flickity').playPlayer();
            });
        }
        else {
            $slider.flickity({
                cellAlign: 'left',
                contain: true
            });
        }
    }

    function initMobileSlider() {
        var mobileSlider
        if ( $win.width() < 767 ) {
            mobileSlider = $('.js-slider-mobile .main-carousel');

            mobileSlider.on( 'ready.flickity', function() {
                $(this).find('.flickity-button').css('top', $(this).find('figure').outerHeight()/2);
            });
            mobileSlider.flickity({
                cellAlign: 'left',
                contain: true,
            });
        } else if ( $win.width() > 767 && $('.js-slider-mobile .flickity-enabled').length > 0) {
            $( mobileSlider ).each(function( index, elm ) {
                elm.destroy()
            });
        }
    }

    function initRolexTippy() {
        const $modelTipElement = $('#rolex-price-tooltip');
        const text = $modelTipElement.data("text");

        if ($modelTipElement.length > 0) {
            tippy('#rolex-price-tooltip', {
                content: text,
                placement: 'auto-start',
                theme: 'rolex',
                arrow: true
            });
        }
    }

    function fixHeights() {
        setTimeout(function(){
            var navHeight = $win.innerHeight() - $('.bar-utilities').outerHeight();
            $('.header .header__nav-inner').css('height', navHeight);
    
            if ($win.width() < 767) {
                var navHeight = $win.innerHeight() - $('.header').outerHeight();
                $('.header .header__nav-inner').css('height', navHeight);
            }

            let $headerHeight = $('.header').outerHeight();

            // check if #wpadminbar is present
            if ($('#wpadminbar').length > 0) {
                $headerHeight += $('#wpadminbar').outerHeight();
            }
    
            // Set css --header-height variables
            document.documentElement.style.setProperty('--header-height', $headerHeight + 'px');
        }, 200);
    }

    function clickHandlers() {
        $('.js-toggle').on('click', function(e){
            e.preventDefault();
            $('.header').toggleClass('is-open');

            if ($win.width() < 767) {
                $(this).toggleClass('is-active');
                $('.search').removeClass('visible')
                $('.search').removeClass('results-load');
                $('.search .search__field').val('');
                $('.header .header__nav').css('top', $('.header').outerHeight());
            }
        })

        $doc.on('click', function(e){
            var $trigger = e.target;
            if (!$($trigger).parents('.header__nav-inner').length > 0 && $('.header').hasClass('is-open')) {
                if ($($trigger).hasClass('js-toggle')) {
                    return;
                }
                if ($win.width() > 767) {
                    $('.header').removeClass('is-open');
                }
            }
        })

        $('.nav-close').on('click', function(e){
            e.preventDefault();
            $('.header__nav-submenu').removeClass('open')
            $('.header').removeClass('is-open');
        })

        $('.js-nav > ul > li > a').on('mouseover', function(e){
            if (touch) {
                return;
            }
            $('.header__nav-submenu').removeClass('open')
            var target = $(this).data('target');
            $(target).addClass('open')
            var $width = $(target).outerWidth();
        })

        $('.js-nav > ul > li > a.has-dropdown').on('click', function(e){
            e.preventDefault();
            if (touch) {
                $('.header__nav-submenu').removeClass('open')
                var target = $(this).data('target');
                $(target).addClass('open')
                var $width = $(target).outerWidth();
            }
        })

        $('.js-close-subnav').on('click', function(e){
            e.preventDefault();
            $('.header__nav-submenu').removeClass('open')
        })

        $('.js-search').on('click', function(e){
            e.preventDefault()
            var searchTop = $('.bar-utilities').outerHeight();

            if ($win.width() < 767) {
                searchTop = $('.header').outerHeight() - 2;
            }

            $('.search').css('top', searchTop).toggleClass('visible')
            $('.search').removeClass('results-load');
            $('.search .search__field').val('');

            if ($win.width() < 767) {
                var searchHeight = $win.innerHeight() - $('.header').outerHeight();
                $('.search').css('height', searchHeight)
            }
        })

        $('.search input').on('keyup', function() {
            if ($(this).val().length > 3 && (enteredSearchTerm != $(this).val())) {
                $.ajax({
                    dataType: 'html',
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        term: $(this).val(),
                        action: 'search'
                    },
                    success: function(html) {
                        $('.search').addClass('results-load');
                        $('.search__results').html(html);
                    }
                });
                return;
            }
            else {
                $('.search__results').html('');
                $('.search').removeClass('results-load');
            }
        })

        $(".js-filters").on('click', function(e){
            e.preventDefault()

            if ($win.width() < 767) {
                $('.js-filters-container').removeClass('visible')
                $('body').removeClass('fixed');
                return;
            }

            $('.js-filters-section').toggleClass('filter-hidden')
        })

        $(".js-open-filters").on('click', function(e){
            e.preventDefault()
            if ($win.width() < 767) {
                $('.js-filters-container').addClass('visible');
                $('body').addClass('fixed');
            }
        })

        if ($('.js-price-range').length > 0) {
            let $priceSliderJq = $('.js-price-range').find('#price-slider').first();
            let $priceSlider   = $priceSliderJq[0];
            let min            = $priceSliderJq.data('slider-min');
            let max            = $priceSliderJq.data('slider-max');
            let from           = $priceSliderJq.data('slider-from');
            let to             = $priceSliderJq.data('slider-to');
            let absMax         = $priceSliderJq.data('slider-abs-max');

            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            noUiSlider.create($priceSlider, {
                start: [from, to],
                connect: true,
                range: {
                    'min': min,
                    'max': max
                },
                step: 100,
            });
            $priceSlider.noUiSlider.on('update', function (values, handle) {
                var value = values[handle];
                if (handle) {
                    if (value >= absMax) {
                        $('#price-slider-max').val('$' + numberWithCommas(Math.round(value)) + '+');
                    }
                    else {
                        $('#price-slider-max').val('$' + numberWithCommas(Math.round(value)));
                    }
                }
                else {
                    $('#price-slider-min').val('$' + numberWithCommas(Math.round(value)));
                }
            });
        }
        $('.js-apply-price-range').on('click', function () {
            var searchParams    = new URLSearchParams(window.location.search),
                newSearchParams = "",
                termID          = $('#product-filter').data('term-id'),
                min             = $('#price-slider-min').val(),
                max             = $('#price-slider-max').val(),
                absMax          = $('#price-slider').data('slider-abs-max');
            min = min.replace('$', '').replace(',', '');
            max = max.replace('$', '').replace(',', '').replace('+', '');
            searchParams.set('min', min);
            if (max < absMax) searchParams.set('max', max);
            else searchParams.delete('max');
            if (searchParams.toString().length > 0) newSearchParams = '?' + searchParams.toString();
            if ($win.width() <= 767) $('#close-filter').trigger('click');
            updateProductGrid(newSearchParams, termID, ajaxurl);
        })

        $('body').on('added_to_cart', function() {
            var headerHeight = $('.header').outerHeight()
            $('#cart-popup').addClass('visible').css('top', headerHeight);;
            $('body').addClass('fixed fixed--alt');
            $('.ajax_add_to_cart.add_to_cart_button')
                .prop('disabled', false)
                .html('Added, go to checkout')
                .removeClass('ajax_add_to_cart')
                .removeClass('add_to_cart_button')
                .addClass('btn--black')
                .attr('href', '/checkout');

            setTimeout(function() {
                $('.js-close-cart-popup').trigger('click');
            }, 5000);
        });
        $('body').on('adding_to_cart', function ($thisbutton, data) {
            $(data).html('Adding...').prop('disabled', true);
            // $thisbutton.html('Adding...').prop('disabled', true);
        });

        $('.js-close-cart-popup').on('click', function(e){
            e.preventDefault()
            $('#cart-popup').removeClass('visible');
            $('body').removeClass('fixed fixed--alt');
        })

        $doc.on('click', function(e){
            var $trigger = e.target;
            if (!$($trigger).parents('.cart-popup').length > 0 && $('.cart-popup').hasClass('visible')) {
                if ($($trigger).hasClass('js-popup-cart')) {
                    return;
                }

                $('#cart-popup').removeClass('visible');
                $('body').removeClass('fixed fixed--alt');
            }
        })

        $('.js-login').on('click', function(e){
            e.preventDefault()
            var headerHeight = $('.header').outerHeight()
            $('.login-shell').addClass('visible');
            $('#login').addClass('visible');
            $('body').addClass('fixed');
        });

        $('.login-shell').on('click', function (e) {
            $(this).find('.js-close-login').trigger('click');
        });

        $('.js-close-login').on('click', function(e){
            e.preventDefault()
            $('#login').removeClass('visible');
            $('.login-shell').removeClass('visible');
            $('body').removeClass('fixed');
        })

        $('.js-enquire').on('click', function(e){
            e.preventDefault();
            var headerHeight = $('.header').outerHeight()
            $('.enquire-shell').addClass('visible');
            $('#enquire').addClass('visible');
            $('body').addClass('fixed');
            return false;
        })

        $('.enquire-shell').on('click', function (e) {
            $(this).find('.js-close-enquire').trigger('click');
        });

        $('#enquire').on('click', function (e) {
            e.stopPropagation();
        })

        $('.js-close-enquire').on('click', function(e){
            e.preventDefault()
            $('#enquire').removeClass('visible');
            $('.enquire-shell').removeClass('visible');
            $('body').removeClass('fixed');
        })

        $('.js-dropdown > a').on('click', function(e){
            e.preventDefault()
            if ($win.width() < 768) {
                $(this).parent().toggleClass('expanded');
            }
        });

        $('.js-expand-content').on('click', function(e){
            // e.preventDefault();
            if ($win.width() > 767) {
                return;
            }
            $(this).toggleClass('expanded');
            return false;
        });

        $('.js-expand-content').on('click', 'a', function (e) {
            e.stopPropagation();
            return true;
        });

        $('.js-expand-subscribe').on('click', function(e){
            e.preventDefault()
            $('.subscribe').addClass('open');
        });

        $('.js-close-subsbcribe').on('click', function(e){
            e.preventDefault()
            $('.subscribe').removeClass('visible').removeClass('open');
            $('body').removeClass('sticky-subscribe-visible');
            document.cookie = 'subscribe=no; SameSite=lax; Secure';
            setTimeout(function() {
                $('.subscribe.form').remove();
            }, 1000);
        });

        $('#gform_submit_button_140').on('click', function(e){
            e.preventDefault()
            $(this).parents('.enquire .enquire__register').addClass('confirm')
        })

        $('#gform_submit_button_135').on('click', function(e){
            e.preventDefault()
            $(this).parents('.form').addClass('confirm')
        })

        $('.js-toggle-filters').on('click', function(){
            $(this).toggleClass('is-expanded')
                .siblings().toggleClass('is-expanded');
        });

        $('#product_sort').on('change', function () {
            var searchParams    = new URLSearchParams(window.location.search),
                newSearchParams = "",
                termID          = $('#product-filter').data('term-id');
            searchParams.set('sort', $(this).val());
            if (searchParams.toString().length > 0) newSearchParams = '?' + searchParams.toString();
            updateProductGrid(newSearchParams, termID, ajaxurl);
        });

        $('#product-filter').on('change', 'input[type=checkbox]', function (e) {
            var searchParams    = new URLSearchParams(window.location.search),
                newSearchParams = "",
                termID          = $('#product-filter').data('term-id');
            // reset URL back to just include sort, if available
            searchParams.forEach(function (value, key) {
                if (key != 'sort') {
                    searchParams.delete(key);
                }
            });
            $('#product-filter input:checked').each(function () {
                var filterKey = $(this).attr('data-filter-type'),
                    filterVal = $(this).val();
                if (filterVal.length > 0) {
                    if (searchParams.get(filterKey) != null) {
                        searchParams.set(filterKey, searchParams.get(filterKey) + ',' + filterVal);
                    }
                    else {
                        searchParams.set(filterKey, filterVal);
                    }
                }
            });
            if (searchParams.toString().length > 0) newSearchParams = '?' + searchParams.toString();
            updateProductGrid(newSearchParams, termID, ajaxurl);
        });

        $('#reset-filters').on('click', function () {
            var pathName = window.location.pathname;
            pathName = pathName.replace(/\/$/, '');
            // check if this is a sub category
            var slashCount = (pathName.match(/\//g) || []).length;
            if (slashCount > 2) {
                pathName = pathName.substring(0, pathName.lastIndexOf('/'));
            }
            window.location = window.location.origin + pathName;
            return false;
        });

        $(document).on('click', 'a.page-link', function () {
            var selectedPage    = $(this).data('page'),
                searchParams    = new URLSearchParams(window.location.search),
                newSearchParams = "",
                termID          = $('#product-filter').data('term-id'),
                $productGrid    = $('#product-grid');
            searchParams.set('page', selectedPage);
            if (searchParams.toString().length > 0) newSearchParams = '?' + searchParams.toString();
            // scoot the user to the top of thie grid
            $('html, body').stop().animate({
                scrollTop: $('.js-filters-section').offset().top
            });
            updateProductGrid(newSearchParams, termID, ajaxurl);
            $productGrid.data('page', selectedPage);
            return false;
        });

        $('.select-lng').on('change', function () {
            var selectedLanguage = $(this).val();
            window.location = selectedLanguage;
        });

        $('.js-edit-tracking-preferences').on('click', function () {
            setGdprModalCheckboxes();
            $('.gdpr-popup__view-options').trigger('click');
            return false;
        });
    }

    function setGdprModalCheckboxes() {
        // check to see which options have been selected
        let isEssentialSelected, isAnalyticsSelected, isRolexSelected = false;
        let theEssentialCookie = getCookie('gdpr-essential');
        let theAnalyticsCookie = getCookie('gdpr-analytics');
        let theRolexCookie     = getCookie('gdpr-rolex');
        if (theEssentialCookie.length > 0) {
            if (theEssentialCookie == 'true') isEssentialSelected = true;
        }
        if (theAnalyticsCookie.length > 0) {
            if (theAnalyticsCookie == 'true') isAnalyticsSelected = true;
        }
        if (theRolexCookie.length > 0) {
            if (theRolexCookie == 'true') isRolexSelected = true;
        }

        // set checkbox props
        if (isEssentialSelected) {
            console.log('checked essential true');
            $('#gdpr-cookie-option--essential').prop('checked', true);
        }
        else {
            console.log('checked essential false');
            $('#gdpr-cookie-option--essential').prop('checked', false);
        }
        if (isAnalyticsSelected) {
            console.log('checked analytics true');
            $('#gdpr-cookie-option--analytics').prop('checked', true);
        }
        else {
            console.log('checked analytics false');
            $('#gdpr-cookie-option--analytics').prop('checked', false);
        }
        if (isRolexSelected) {
            console.log('checked rolex true');
            $('#gdpr-cookie-option--rolex').prop('checked', true);
        }
        else {
            console.log('checked rolex false');
            $('#gdpr-cookie-option--rolex').prop('checked', false);
        }
    }

    function refreshProductGridNumbers() {
        if ($('#product-grid-details').length > 0) {
            var $productGridDetails = $('#product-grid-details'),
                productCount        = $productGridDetails.data('product-count'),
                productCountString  = productCount + ' product';
            if (productCount != 1) productCountString += 's';
            $('#product-count').html(productCountString);
        }
    }

    function updateProductGrid(searchParams, termID, ajaxurl) {
        if (history.pushState) {
            var $productGrid = $('#product-grid');
            $productGrid.addClass('loading');
            $.ajax({
                type: 'GET',
                url: ajaxurl + searchParams,
                data: {
                    action: 'product_grid',
                    termID: termID
                },
                success: function (response) {
                    $productGrid.removeClass('loading').html(response);
                    refreshProductGridPagination();
                    refreshProductGridNumbers();
                    var urlParams = new URLSearchParams(searchParams.substring(1));
                    var urlEntries = urlParams.entries();
                    var urlState = paramsToObject(urlEntries);
                    history.pushState(urlState, document.title, window.location.origin + window.location.pathname + searchParams);
                }
            });
        }
        else {
            window.location = window.location.origin + window.location.pathname + searchParams;
        }
        return true;
    }

    function paramsToObject(entries) {
        var result = {};
        for (var [key, value] of entries) {
            result[key] = value;
        }
        return result;
    }

    function refreshProductGridPagination() {
        var $paginationShell   = $('#product-grid-pagination-shell'),
            $productPagination = $('#product-grid-pagination');
        if ($paginationShell.length > 0) {
            var paginationHTML = $productPagination.html();
            paginationHTML = paginationHTML.replace(/\#url\#/g, window.location.origin + window.location.pathname);
            $paginationShell.html(paginationHTML);
            var $paginationLinks = $paginationShell.find('li:not(.prev_page_link):not(.next_page_link)');

            if ($win.width() < 768) {
                // sort out mobile pagination with pagination and all that stuff
                if ($paginationLinks.length == 1) {
                    $paginationLinks.addClass('show-mobile');
                }
                else {
                    var $currentPage = $paginationLinks.filter('.current'),
                        $lastPage    = $paginationLinks.last();
                    $currentPage.addClass('show-mobile');
                    $lastPage.addClass('show-mobile').addClass('show-mobile-of');
                    if ($lastPage.hasClass('current')) {
                        if ($win.width() < 767) {
                            $lastPage.removeClass('show-mobile-of').children('a').html($paginationLinks.length + ' &nbsp; of &nbsp; ' + $paginationLinks.length);
                        }
                    }
                }
            }
            else {
                if ($paginationLinks.length <= 4) {
                    $paginationLinks.addClass('show-desktop');
                }
                else {
                    var $currentPage = $paginationLinks.filter('.current'),
                        $prevPage = $currentPage.prev(':not(.prev_page_link)'),
                        $nextPage = $currentPage.next(':not(.next_page_link)');
                    $currentPage.addClass('show-desktop');
                    if ($prevPage.length > 0) {
                        if ($prevPage.prev().hasClass('prev_page_link')) {
                            // $prevPage is page 1, so don't use ellipsis
                            $prevPage.addClass('show-desktop');
                        }
                        else {
                            $prevPage.addClass('show-ellipsis-before');
                        }
                    }
                    if ($nextPage.length > 0) {
                        if ($nextPage.next().hasClass('next_page_link')) {
                            // $nextPage is last page, so don't use ellipsis
                            $nextPage.addClass('show-desktop');
                        }
                        else {
                            $nextPage.addClass('show-ellipsis-after');
                        }
                    }
                    // show the last page in the set if the current page is page 1
                    if ($currentPage.find('a.page-link').data('page') == 1) $paginationLinks.last().addClass('show-desktop');
                }
            }
        }
        return true;
    }

    function runAccordion() {
        $('.js-accordion .accordion__body').slideUp('slow', function() {
			$doc.trigger( 'efront_header_offset_sticky_refresh', [ 600 ] );
		});
        $('.js-accordion .is-current .accordion__body').slideDown('slow', function() {
			$doc.trigger( 'efront_header_offset_sticky_refresh', [ 600 ] );
		});

        setTimeout(function(){
            if ( $('.js-sticky-filter').length > 0) {
                var sidebarContainer = document.getElementById('sticky-bar');
                sidebar = new StickySidebar(sidebarContainer, {
                    topSpacing: 110,
                    bottomSpacing: 60,
                    minWidth: '36rem'
                });

                if ($win.width() >= 768) {
                    sidebarContainer.addEventListener('affix.top.stickySidebar', function () {
                        $('.js-filters-section').addClass('filter-hidden')
                    });

                    sidebarContainer.addEventListener('affix.static.stickySidebar', function () {
                        $('.js-filters-section').removeClass('filter-hidden')
                    });
                }
            }
        }, 1000);


        $('.js-accordion .accordion__head').on('click tap', function(e) {
            let currentAcc = $(this).parent();
            let accSiblings = currentAcc.siblings('.is-current');
            let accBody = currentAcc.find('.accordion__body');

            if ( currentAcc.hasClass('is-current') ) {
                accBody.slideUp('slow');
                currentAcc.removeClass('is-current');

				$doc.trigger( 'efront_header_offset_sticky_refresh', [ 600 ] );
                return;
            }

            accBody.slideDown();
            currentAcc.addClass('is-current');
            accSiblings
                .removeClass('is-current')
                    .find('.accordion__body')
                        .slideUp();

			$doc.trigger( 'efront_header_offset_sticky_refresh', [ 400 ] );
        });
    }

    function scrollHandlers(st){
        var $header = $('.header');

        $('.js-fade').css('opacity', 1-(st/($win.height()/1.3)));

        var headerStickyLimit = 175;
        if ($win.width() <= 1023) headerStickyLimit = 143;
        if ($win.width() <= 767) headerStickyLimit = 70;

        if ( st < headerStickyLimit && $header.hasClass("sticky") ) {
            $header.removeClass("sticky");
        } else if (st > headerStickyLimit && !$header.hasClass("sticky")) {
            $header.addClass("sticky")
        }

        // if ( st > $win.innerHeight() && $("#cart-popup").hasClass("visible") ) {
        //     $("#cart-popup").removeClass("visible")
        //     $('body').removeClass('fixed fixed--alt');
        // }
        setTimeout(function(){
            $('.header .header__nav').css('top', $('.header').outerHeight());
            $('#cart-popup').css('top', $('.header').outerHeight());
            if ($win.width() > 767) {
                if ($('.search').hasClass('visible')) {
                    if ($('.header').hasClass('sticky')) {
                        $('.search').css('top', $('.header').outerHeight());
                    }
                    else {
                        $('.search').css('top', $('.bar-utilities').outerHeight());
                    }
                }
            }
        }, 400);
    }

    function initPopup(){
        var popup = $('.js-popup-video').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true
        });

        var popup2 = $('.js-popup-video-featured').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true,
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: function(url) {
                            var m = url.match(/^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/);
                            return (m && m[1]) ? m[1] + '?' : null;
                        },
                        src: 'https://www.youtube.com/embed/%id%controls=1&rel=0'
                    },
                    vimeo: {
                        index: 'vimeo.com',
                        id: function(url) {
                            var m = url.match(/^(.+)vimeo\.com\/([0-9a-z]+)(\/[0-9a-z]+)?/);
                            if (m !== null) {
                                if (m[3] !== undefined) {
                                    return m[2] + "?h=" + m[3].replace('/', '') + "&";
                                }
                                else if (m[2] !== undefined) {
                                    return m[2] + "?";
                                }
                            }
                            else return null;
                        },
                        src: 'https://player.vimeo.com/video/%id%'
                    }
                }
            }
        });

        var imagePopup = $('.js-full-screen-image').magnificPopup({
            type: 'image',
            mainClass: 'mfp-fade',
            removalDelay: 100,
            fixedContentPos: true,
            image: {
                verticalFit: true
            }
        });

        $('.mfp-close').click(function(){
            $.magnificPopup.close();
            $(this).parents('.popup').removeClass('popup--alt')
        });
    }

    $.fn.equalizeHeight = function() {
        var hght = 0;
        var $this = this;

        $this.outerHeight('auto');

        $this.each(function(){
            var itemHght = $(this).outerHeight();

            if (itemHght > hght) {
                hght = itemHght;
            }
        });

        $this.outerHeight(hght);
    }

    function initSelect() {
        $('.select-lng').selectric();
        $('.js-select-simple').selectric();

        // Woocommerce Variations
        $('.variations select').selectric();

        // Listen for WooCommerce variation changes
        $('form.variations_form').on('woocommerce_variation_has_changed woocommerce_update_variation_values', function() {
            // Destroy and reinitialize Selectric
            $('.variations select').selectric('destroy').selectric();
        });
    }

    function initCookies() {
        if (document.cookie.split('; ').some((item) => item.trim().startsWith('subscribe='))) {
            var cookieValue = document.cookie.split('; ').find(row => row.startsWith('subscribe=')); // .split('=')[1];
            if (typeof cookieValue != 'undefined') {
                var showSubscribe = cookieValue.split('=')[1];
                if (showSubscribe == 'no') {
                    $('.subscribe.form').remove();
                }
            }
        }
        initUtmCookies();
    }

    function setSticky() {
        if ($win.width() < 767) {
            return;
        }

        var sidebar;
        var scrollSections = $('.section-scroll');
        if (scrollSections.length > 0) {

            $( scrollSections ).each(function( index, elm) {
                var stickyContent = $($(elm).find('.sticky-content'))[0];
                sidebar = new StickySidebar(stickyContent, {
                    topSpacing: 0,
                    bottomSpacing: 0
                });
            });
        }

        if ( $('.js-fade-on-scroll').length > 0) {
            sidebar = new StickySidebar('.js-fade-on-scroll', {
                topSpacing: 60,
                bottomSpacing: 0
            });
        }
	}

	function setHeaderOffsetScrollSections() {
        if ($win.width() < 767) {
            return;
        }

		// Couldn't use sticky classes in setSticky() due to pre-defined styles & needing a top offset due to the dynamic header height.

		// Used to refresh StickySidebar objs on 'efront_header_offset_sticky_refresh' event (e.g. on product desc accordion open/close).
		window.scrollSections = [];

        var scrollSections = $('.js-sticky-section');

        if ( scrollSections.length > 0 ) {
            $( scrollSections ).each(function( index, elm) {
				var stickyContent = $( elm ).find('.js-sticky-content').length ? $( elm ).find('.js-sticky-content')[0] : elm;

                var sidebar = new StickySidebar( stickyContent, {
                    topSpacing: 50,
                    bottomSpacing: 0,
                });

				window.scrollSections.push( sidebar );
            });
        }
	}

    function animateLabel() {
        $('.form input:not([type=radio]), .form-enquire input, .form-checkout input, .form textarea, .form-enquire textarea, .form-checkout textarea').on('keyup', function(){
            var inputLabel = $(this).attr('id');
            if ($(this).val() != "") {
                $(this).addClass('animated')
                $( "label[for=" + inputLabel + "]").addClass('animated')
            }
        })

         $('.form input:not([type=radio]), .form-enquire input, .form-checkout input, .form textarea, .form-enquire textarea, .form-checkout textarea').on('focusout', function(){
            var inputLabel = $(this).attr('id');
            if ($(this).val() == "") {
                $(this).removeClass('animated')
                $( "label[for=" + inputLabel + "]").removeClass('animated')
            }
         });

         $('.module__text-content input[type=text]').on('focus', function () {
             var $this = $(this);
             $this.addClass('animated-label');
         });
         $('.module__text-content input[type=text]').on('keyup', function () {
            var $this = $(this);
            if ($this.val() != "") {
                $this.addClass('animated-label');
            }
         });
         $('.module__text-content input[type=text]').on('focusout', function () {
             var $this = $(this);
             if ($this.val() == '') {
                 $this.removeClass('animated-label');
             }
         });
    }

    function startSubscriptionTimeout() {
        if (!$('body').hasClass('home') && !window.location.pathname.includes('/rolex')) {
            setTimeout(function(){
                openSubscribe()
            }, 20000);
        }
    }
    
    function openSubscribe() {
        $('.subscribe').addClass('visible').closest('body').addClass('sticky-subscribe-visible');
    }

    function customScrollbar() {
        $('.js-container').mCustomScrollbar();
    }

    function initMap() {
        if ( !$('#map').length ) {
            return;
        }
        var icon;
        var image = '/wp-content/themes/wos/assets/dist/images/pin.svg';
        var lat = parseFloat($('#map').attr('data-lat'));
        var lng = parseFloat($('#map').attr('data-lng'));
        const myLatLng = {lat: lat, lng: lng}
        map = new google.maps.Map(document.getElementById('map'), {
            center: myLatLng,
            zoom: 16,
            styles: mapStyles,
        });

        icon = {
            url: image,
        }

        if ( $win.width() < 767 ) {
            icon = {
                url: image,
                scaledSize: new google.maps.Size(39, 60)
            }
        }

        const marker = new google.maps.Marker({
            position: myLatLng,
            map,
            icon: icon,
        });
    }

    function mapResize() {
        if ( !$('#map').length ) {
            return;
        }

        if ( $win.width() < 767 ) {
            map.setZoom(12);
        }
    }

    function fadeOnScroll(st) {
        if ( $('.js-fade-on-scroll').length == 0 ) {
            return;
        }

        var scrollHolderHeight = $('.js-fade-on-scroll-holder').height();
        var scrollHolderTop = $('.js-fade-on-scroll-holder').offset().top;

        if (st > (scrollHolderHeight * .3 + scrollHolderTop)) {
            $('.js-fade-on-scroll').addClass('visible')
        }

        if (st < (scrollHolderHeight * .3 + scrollHolderTop)) {
            $('.js-fade-on-scroll').removeClass('visible')
        }
    }

    function customCursor() {
        var $cursor = $('.cursor');

        $('.js-slider .flickity-button').on('mousemove', function(e){
            $cursor.addClass('visible')
            var currentMousePos = { x: -1, y: -1 };
            currentMousePos.x = e.pageX;
            currentMousePos.y = e.pageY
            $cursor.css({"top": currentMousePos.y, "left": currentMousePos.x});
            var containerCenter = $(this).innerWidth();

            if (currentMousePos.x < containerCenter) {
                $cursor.addClass('left')
            } else {
                $cursor.removeClass('left')
            }
        });

        $('.js-slider .flickity-button').on('mouseleave', function(e){
            $cursor.removeClass('visible')
        })
    }

    function sectionScrollContent() {
        if ( $win.width() < 767 ) {
            return;
        }
        if ($('.section-slider').length > 0) {
            var sidebar = new StickySidebar('.section-slider .section__background', {
                topSpacing: 50,
                bottomSpacing: 0
            });
        }
    }

    function sectionScrollOverlay(st) {
        if ( $('.section-slider').length == 0) {
            return;
        }

        if ( $win.width() < 767 ) {
            return;
        }

        var sb = st + $win.innerHeight()
        var sectionSliderTop = $('.section-slider').offset().top;
        var sectionSliderBottom = sectionSliderTop + $('.section-slider').innerHeight();

        var overlay = $('.section-slider .section__overlay')
        if (st > sectionSliderTop && sb < sectionSliderBottom) {
            var opacity = ((st - sectionSliderTop) * .00024) + .44
            var r = (st - sectionSliderTop) * .079;
            var g = (st - sectionSliderTop) * .070;
        var b = (st - sectionSliderTop) * .058;
            var color = "#87715A"
            overlay.css({
                opacity: opacity,
                backgroundColor: color,
            });
        }
    }

    function destroyFlickity() {
        if ($win.width() > 767) {
            $('.flickity-enabled.resize-desktop-destroy-flickity').flickity('destroy');
        }
    }

    function fixFilterButtonMobile() {
        if ($win.width() < 768) {
            $('.js-filters-section').removeClass('filter-hidden');
        }
    }

    $('#gdpr-popup-options-form').on('submit', function () {
        return false;
    });
    
    function initGDPR() {
        console.log('init gdpr');
        // check satellite
        /*
        if (typeof _satellite != 'undefined') {
            var satelliteStatus = _satellite.getVar('Analyticsconsent');
            if (typeof satelliteStatus == 'undefined') _satellite.setVar('Analyticsconsent', 'false');
        }
        */

        // check rolex tracking code
        if (getCookie('rlx-consent').length == 0) {
            console.log('client has never seen rlx-consent cookie before, set it to false');
            setCookie('rlx-consent', 'false', 365);
        }

        if (!hasSeenGDPR()) {
            console.log('has not seen gdpr');
            $('.gdpr-popup-request').addClass('visible');
        }

        $('.gdpr-popup__accept').on('click', function () {
            console.log('trigger gdpr accept')
            acceptGDPR();
            $('.gdpr-popup-request').removeClass('visible');
            $('.gdpr-popup-request').remove();
            startSubscriptionTimeout();
            return false;
        });

        $('.gdpr-popup__decline').on('click', function () {
            console.log('trigger gdpr decline');
            $('.gdpr-popup-request').removeClass('visible');
            $('.gdpr-popup-request').remove();
            declineGDPR();
            startSubscriptionTimeout();
            return false;
        });

        $('.gdpr-popup__view-options').magnificPopup({
            type: 'inline',
            midClick: true,
            modal: true,
            callbacks: {
                open: function () {
                    $('.gdpr-popup-request').removeClass('visible');
                },
                close: function () {
                    // only if the user has cancelled selecting any option (aka Discard Changes)
                    $('.gdpr-popup-request').addClass('visible');
                }
            }
        });

        $('#gdpr-cookie-option-accept-selected').on('click', function () {
            console.log('click accept selected');
            let selectedGdprOptions = {};
            $('input[name="gdpr-cookie-option"]').each(function () {
                var selectedOption = $(this).val();
                if ($(this).is(':checked')) selectedGdprOptions[selectedOption] = true;
                else selectedGdprOptions[selectedOption] = false;
            });
            selectedGdprOptions.essential = true;
            applyGDPRSettings(selectedGdprOptions);
            $.magnificPopup.close();
            $('.gdpr-popup-request').removeClass('visible');
            // $('.gdpr-popup-request').remove();
            return false;
        });
        $('#gdpr-cookie-option-accept-all').on('click', function () {
            console.log('click accept all');
            $('input[name="gdpr-cookie-option"]').each(function () {
                $(this).prop('checked', true);
            });
            $('#gdpr-cookie-option-accept-selected').trigger('click');
            return false;
        });
        $('#gdpr-cookie-option-discard-changes').on('click', function () {
            console.log('click discard changes');
            $.magnificPopup.close();
            $('.gdpr-popup-request').addClass('visible');
            return false;
        });

        // set checkboxes according to cookies, if set
        setGdprModalCheckboxes();
    }

    const initPlyr = () => {
        $('.plyr--main').each(function(plyrIndex) {
            try {
                let $this = $(this);
                let videoId = $this.attr('id') + '_' + plyrIndex; // Append the index to the id
                $this.attr('id', videoId); // Update the id of the element

                let autoplay = $this.attr('data-autoplay') === 'true';
                let videoType = $this.data('video-type');
                let poster = $this.attr('data-poster');
                let allowFullscreen = $this.attr('data-allow-fullscreen') === 'true';
    
                let controls = $this.attr('data-controls') === 'true' ? ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'] : [];
                if ($this.attr('data-mute-button') === 'true') {
                    controls = ['mute'];
                }
    
                const videoSettings = {
                    clickToPlay: $this.attr('data-click-to-play') === 'true',
                    controls: [],
                    loop: { active: $this.attr('data-loop') === 'true' },
                    autoplay: autoplay && videoType === "embed",
                    fullscreen: { enabled: allowFullscreen },
                    storage: { enabled: false },
                    muted: true,
                };
    
                const player = new Plyr('#' + videoId, videoSettings);

                const index = players.length;
                players.push(player);
    
                // Get the classes from the initial Plyr element
                let classes = $this.attr('class');
    
                // Add the classes to the new Plyr element
                $(players[index].elements.container).addClass(classes);
    
                if ( poster ) {
                    players[index].poster = $this.attr('data-poster');
                }
    
                if(autoplay && videoType === "file") {
                    players[index].volume = 0;
                    players[index].muted = true;
                }
    
                const config = {
                    rootMargin: '0px -100px',
                    threshold: 0
                }
                
                const callback = (entries) => {
                    entries.map((entry) => {
                        entry.isIntersecting && autoplay && players[index] ? players[index].play() : players[index].pause();
                    });
                };
    
                let observer = new IntersectionObserver(callback, config);

                // Banner Video Settings
                
                let $bannerParent = $(this).parents(".section--hero-banner__slide").eq(0);

                if($bannerParent && $bannerParent.length) {
                    // find .js-mute-button
                    let $muteButton = $bannerParent.find('.js-mute-button');

                    if($muteButton && $muteButton.length) {
                        $muteButton.on('click', function() {
                            if(player.volume == 0) {
                                players[index].increaseVolume(1);
                            } else {
                                players[index].decreaseVolume(1);
                            }

                            $muteButton.toggleClass('is-muted');
                        });
                    }
                }
    
                players[index].on('ready', () => {
                    players[index].pause();
                    players[index].muted = true;
                    players[index].volume = 0;

                    if(autoplay) {
                        players[index].play();
                    }
                    observer.observe($this[0]);
                });
            } catch (error) {
    
                if(error.message !== "Plyr is not defined") {
                    console.error('Error initializing Plyr:', error);
                } else {
                    console.error('Plyr is not defined.');
                }   
            }
        });
    }

    const initBannerSlider = () => {
        $('.section--hero-banner').each(function() {
            const $slider = $(this).find('.section--hero-banner__slides');

            $slider.on('init', function(event, slick) {
                initPlyr();
            });

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: $slider.find('.section--hero-banner__slide').length > 1,
                arrows: false,
                fade: false, // Ensure this is false to improve performance
                pauseOnHover: false, // Consider disabling for mobile
                pauseOnFocus: false, // Consider disabling for mobile
                infinite: true,
                speed: 400, // Reduced speed for snappier transitions
                useTransform: true, // Ensure hardware acceleration is used
            });
        });
    }

    $win.on('load', function () {
        if ($('body').hasClass('is_rolex')) {
            initGDPR()
        }
        else {
            startAnalytics();
        }
        clickHandlers()
        refreshProductGridNumbers()
        refreshProductGridPagination()
        animateLabel()
        runAccordion()
        customScrollbar()
        initMap()
        customCursor()
        sectionScrollContent()

        $('img[data-image-modal]').imageModal();

        if (hasAcceptedGDPR()) {
            initCookies()
            startSubscriptionTimeout();
            applyTrackingSettings();
        }

        $('.wrapper').addClass('loaded')
    }).on('scroll load', function(){
        st = $win.scrollTop()
        if (st > lastSt) {
            scrollDir = 'down';
        }
        else {
            scrollDir = 'up';
        }
        lastSt = st <= 0 ? 0 : st; // for mobile or negative scrolling
        scrollHandlers(st)
        sectionScrollOverlay(st)
    }).on('load resize', function(){
        initMobileSlider()
        mapResize()
        setSticky()
		setHeaderOffsetScrollSections()
        destroyFlickity()
        fixHeights()
        let vh = $win.innerHeight() * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        $('.eq-height1').equalizeHeight();

		var $subscribe_banner = $('.subscribe.form');

		if ( $subscribe_banner.length ) {
			// Used in hero & 'brand specific gateway' modules to ensure the subscribe banner doesn't overlap the bottom aligned text content.
			document.documentElement.style.setProperty( '--subscribe_banner_height', $subscribe_banner.outerHeight() + 'px' );
		}

        var $gdpr_banner = $('.gdpr-popup-request');
        if ($gdpr_banner.length) {
            document.documentElement.style.setProperty('--gdpr_banner_height', $gdpr_banner.outerHeight() + 'px');
            document.documentElement.style.setProperty('--gdpr_banner_height_offset', -1 * $gdpr_banner.outerHeight() + 'px');
        }
    }).on('resize', function () {
        fixFilterButtonMobile()
        $('.flickity-enabled').flickity('reloadCells');
    }).on('scroll', function(){
        st = $win.scrollTop()
        fadeOnScroll(st)
    })
    

    $('body').on('click', '.product__star, .product__wishlist', function(e){
        var $thisStar = $(this);
        if (typeof $thisStar.data('productid') != 'undefined') {
            if ($thisStar.hasClass('product__wishlist')) {
                var $starIcon  = $thisStar.children('.ico-star'),
                    $starLabel = $thisStar.children('span');
                if ($starIcon.hasClass('is-selected')) {
                    $starLabel.html('Removing...');
                }
                else {
                    $starLabel.html('Adding...');
                }
            }
            else {
                $thisStar.parents('.product').addClass('loading');
            }
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajaxurl,
                data: {
                    action: 'wishlist_toggle',
                    productID: $thisStar.data('productid'),
                    listID: $thisStar.data('listid')
                },
                success: function (response) {
                    $thisStar.parents('.product').removeClass('loading');
                    if (response.status == 'ok') {
                        $thisStar.find('.ico-star').toggleClass('is-selected');
                        if (typeof response.listID != 'undefined') {
                            if ($thisStar.hasClass('product__star')) {
                                $('.product__star').each(function () {
                                    if ($(this).attr('data-listid') == '') {
                                        $(this).attr('data-listid', response.listID);
                                    }
                                });
                            }
                            else {
                                if (response.starStatus == 'removed') {
                                    $thisStar.children('span').html('Add to wishlist');
                                }
                                else {
                                    $thisStar.children('span').html('Added to wishlist');
                                }
                            }
                        }
                    }
                    else {
                        alert(response.message);
                    }
                }
            });
        }
        return false;
    })

	// Destroy and re-init the header offset sticky scroll sections.
	$doc.on('efront_header_offset_sticky_refresh', function( e, delay ) {
		var delay = typeof delay !== 'undefined' ? parseFloat( delay ) : 0;

		setTimeout(function(){
			if ( window.scrollSections && window.scrollSections.length ) {
				$.each( window.scrollSections, function() {
					// Plugin has a updateSticky() method but it didn't seem to recalculate heights properly.
					this.destroy();
				});

				// Re-init sticky sections.
				setHeaderOffsetScrollSections();
			}
		}, delay);
	});

	$('.btn--mute, .btn--rewind').on('click', function () {
		// locate the vimeo video that's nearest to this button
		if ($(this).parents('.module-homepage__featured-video').length > 0) {
			var $vimeo = $(this).siblings('iframe').first();
		}
		else if ($(this).parents('.hero').length > 0) {
            if (window.width < 768 && $(this).parents('.hero').find('.hero__bg-video-mobile').length > 0 ) {
                var $vimeo = $(this).parents('.hero').find('.hero__bg-video-mobile.visible-sm-block iframe');
            }
            else {
                var $vimeo = $(this).parents('.hero').find('.hero__bg-video.visible-lg-block iframe');
            }
		}
		if ($vimeo.length > 0) {
            var vimeoPlayer = new Vimeo.Player($vimeo[0]);
            if ($(this).hasClass('btn--mute')) {
                if ($(this).hasClass('btn--mute-muted')) {
                    vimeoPlayer.setVolume(1);
                    $(this).removeClass('btn--mute-muted');
                }
                else {
                    vimeoPlayer.setVolume(0);
                    $(this).addClass('btn--mute-muted');
                }
            }
            else if ($(this).hasClass('btn--rewind')) {
                vimeoPlayer.setCurrentTime(0);
            }
		}
		return false;
	});

    const initVariationSelect = () => {
        // Cache DOM elements
        const $priceElement = $('.product__head-entry h3');
        const originalPrice = $priceElement.html();
    
        // Helper function to format number with commas
        const numberWithCommas = (x) => {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };
        
        // When variation is selected
        $('.variations_form').on('show_variation', function(event, variation) {
            if (!variation || !variation.display_price) {
                $priceElement.html(originalPrice);
                return;
            }
            
            // Hide WooCommerce's default variation price display
            $('.woocommerce-variation-price').hide();
            
            // Update the main price element with new variation price
            $priceElement.html("$" + numberWithCommas(variation.display_price));
        });
        
        // When variations are hidden (invalid combination)
        $('.variations_form').on('hide_variation', function() {
            $priceElement.html(originalPrice);
        });
    }

    // Handle variation changes
    $(document).on('show_variation', 'form.variations_form', function(event, variation) {
        if (variation && variation.image && variation.image.src) {
            // Get the first carousel image
            const firstCarouselImage = $('.main-carousel .carousel-cell:first-child img');
            
            if (firstCarouselImage.length) {
                // Store the original image source if not already stored
                if (!firstCarouselImage.data('original-src')) {
                    firstCarouselImage.data('original-src', firstCarouselImage.attr('src'));
                    firstCarouselImage.data('original-srcset', firstCarouselImage.attr('srcset'));
                }
                
                // Update image with variation image
                firstCarouselImage.attr('src', variation.image.src);
                if (variation.image.srcset) {
                    firstCarouselImage.attr('srcset', variation.image.srcset);
                }
            }
        } else {
            // If no variation is selected, reset to original image
            const firstCarouselImage = $('.main-carousel .carousel-cell:first-child img');
            if (firstCarouselImage.length && firstCarouselImage.data('original-src')) {
                firstCarouselImage.attr('src', firstCarouselImage.data('original-src'));
                if (firstCarouselImage.data('original-srcset')) {
                    firstCarouselImage.attr('srcset', firstCarouselImage.data('original-srcset'));
                }
            }
        }
    });

    // Handle reset variations
    $(document).on('reset_image reset_data', 'form.variations_form', function() {
        const firstCarouselImage = $('.main-carousel .carousel-cell:first-child img');
        
        if (firstCarouselImage.length && firstCarouselImage.data('original-src')) {
            // Restore original image
            firstCarouselImage.attr('src', firstCarouselImage.data('original-src'));
            if (firstCarouselImage.data('original-srcset')) {
                firstCarouselImage.attr('srcset', firstCarouselImage.data('original-srcset'));
            }
        }
    });
    

    initVariationSelect()
    initSliders()
    initMobileSlider()
    initRolexTippy()
    initBannerSlider()
    fixHeights()
    initPopup()
    initSelect()
})(jQuery, window, document);





